export interface TreeviewSelection {
    checkedItems: CheckboxTreeviewItem[];
    uncheckedItems: CheckboxTreeviewItem[];
}
export interface CheckboxItem {
    text: string;
    value: any;
    disabled?: boolean;
    checked?: boolean;
    someChecked?: boolean;
    noneChecked?: boolean;
    collapsed?: boolean;
    children?: CheckboxItem[];
    parent?: CheckboxItem;
}
export class CheckboxTreeviewItem {
    constructor(item: CheckboxItem) {
        this.text = item.text;
        this.value = item.value;
        this.disabled = item.disabled;
        this.checked = item.checked;
        this.someChecked = item.someChecked;
        this.noneChecked = item.noneChecked;
        this.collapsed = item.collapsed;
        this.children = item.children;
        this.parent = item.parent;
    }

    text: string;
    value: any;
    disabled: boolean;
    checked: boolean;
    someChecked: boolean;
    noneChecked: boolean;
    collapsed: boolean;
    children: CheckboxItem[];
    parent: CheckboxItem;
}